import styles from "./notfound.module.scss";
import { ReactComponent as PhoneIcon } from "./icons/phone.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { TerminalType_Enum } from "services/sale/common/enums";

export const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  function handleNavigate() {
    if (location.state && location.state.platform) {
      switch (location.state.platform) {
        case TerminalType_Enum.Driver:
          navigate("/driver");
          break;
        case TerminalType_Enum.PassengerApp:
          navigate("/passenger");
          break;
        case TerminalType_Enum.Counter:
          navigate("/counters");
          break;
        case TerminalType_Enum.Kiosk:
          navigate(`/kiosk/${location.state.id}/home`);
          break;
        case TerminalType_Enum.Panel:
          navigate(`/panel/manage`);
          break;
        default:
          break;
      }
    } else navigate(-1);
  }

  const hideManageLayout = `
  .hide-manageLayout {
    display: none;
  }
  `;

  return (
    <>
      <style>{hideManageLayout}</style>
      <div className={styles["_"]}>
        <h3 className={styles["_title"]}>SEPARTA</h3>

        <p className={styles["_message"]}>صفحه مورد نظر یافت نشد</p>

        {/* <p className={styles["_detail"]}>
        در برقراری ارتباط مشکلی پیش آمده است لطفا از وجود اینترنت مطمئن و دوباره
        تلاش کنید
      </p>

      <div className={styles["_call_info"]}>
        <PhoneIcon /> <span>رزرو تلفنی</span>{" "}
        <span className={styles["_phone-number"]}>021 91301278</span>
      </div> */}

        <button className="btn btn-warning" onClick={handleNavigate}>
          بازگشت به خانه
        </button>
      </div>
    </>
  );
};
